import type { Breadcrumb } from '@do/svelte-seo';

import { joinPath } from '@shared/utils';

export function buildFilterPagePath({ baseUrl, filters, page }: { baseUrl: string; filters?: string; page?: number }) {
  const filtersString = filters ? `${filters}` : '';
  const pageString = page && page > 1 ? `page-${page}` : '';

  if (!filtersString && !pageString) {
    return '';
  }

  const path = joinPath(baseUrl, filtersString, pageString);

  return `/${path}/`;
}

export function extendBreadcrumbsWithSlug({
  baseBreadcrumbs,
  slug,
  name,
}: {
  baseBreadcrumbs: Breadcrumb[];
  slug: string;
  name: string;
}): Breadcrumb[] {
  if (!slug) {
    return baseBreadcrumbs;
  }

  return [
    ...baseBreadcrumbs,
    {
      name,
      slug,
      canonical: true,
    },
  ];
}
